export default {"src":"/uk/_next/static/media/beneficiariesIcon.b4791ba0.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};